import LegalPage from "../components/site/LegalPage";
import fuente from "../content/legal/aviso-de-privacidad.md";

// /privacidad — Aviso de Privacidad (src/content/legal/aviso-de-privacidad.md).
export default function PrivacidadPage() {
  return (
    <LegalPage
      fuente={fuente}
      ruta="/privacidad"
      titulo="Aviso de Privacidad · SoyPacoIA"
      descripcion="Qué datos personales tratamos en SoyPacoIA y Lorena, para qué los usamos, con quién se comparten y cómo ejercer tus derechos."
      otra={{ ruta: "/terminos", texto: "Términos del Servicio" }}
    />
  );
}
